export default __webpack_public_path__ + "static/rolling_door_b.26091696331ece403be949b5358eefba.png";